import {
  effect,
  inject,
  Injectable,
  Signal,
  signal,
  Injector,
  runInInjectionContext,
} from '@angular/core';
import { ProfileService } from '../profile/profile.service';
import { TiersService } from '../tiers/tiers.service';
import { DepositService } from '../deposit/deposit.service';
import { DepositWatcherService } from '../deposit/deposit-watcher.service';
import { DepositCheckerService } from '../deposit/deposit-checker.service';
import { OperatorService } from '../operator/operator.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  private profileService = inject(ProfileService);
  private tiersService = inject(TiersService);
  private depositService = inject(DepositService);
  private depositChecker = inject(DepositCheckerService);
  private depositWatcher = inject(DepositWatcherService);
  private operatorService = inject(OperatorService);
  private injector = inject(Injector);

  private initialisedSignal = signal<boolean | undefined>(undefined);

  initialise() {
    runInInjectionContext(this.injector, () => {
      effect(
        async () => {
          const initialised = this.profileService.initialised();
          if (initialised) {
            const userId = this.profileService.userId;

            this.depositChecker.initialise(
              this.operatorService.operatorId,
              this.operatorService.operatorPlatform,
            ),
              await Promise.all([
                this.depositWatcher.initialise(),
                this.depositService.initialise(userId),
                this.tiersService.refresh(),
              ]);

            this.initialisedSignal.set(true);
          }
        },
        { allowSignalWrites: true },
      );
    });
  }

  get initialised(): Signal<boolean | undefined> {
    return this.initialisedSignal.asReadonly();
  }
}
